<template>
  <div class="mt-5">
    <section-title
      content="Áreas Geográficas"
      icon="fas fa-map-marker-alt"
      reverse
    />
    <div class="bg-secondary-3 rounded pr-3 pl-3 mt-3 pb-4 pt-4">
      <div class="color-gray-6 font-14">
        Municipio(s):
      </div>
      <div class="items__container">
        <span v-for="item in items" :key="item.id" class="item__container">
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';

export default {
  name: 'GeneralInformation',
  components: {
    SectionTitle,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.items__container {
  display: flex;
}

.item__container {
  background-color: white;
  margin: 5px;
  padding: 4px 8px;
  border: 1px solid #d6ddd9;
  border-radius: 20px;
  margin-left: 0;
}
</style>
